import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { requestPasswordReset } = useAuth();
  
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    
    try {
      const result = await requestPasswordReset(data.email);
      
      if (result.success) {
        setEmailSent(true);
        toast.success('Se ha enviado un enlace de recuperación a tu correo');
      } else {
        toast.error(result.error);
      }
    } catch (error) {
      toast.error('Error inesperado al solicitar recuperación');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="login-bg d-flex align-items-center justify-content-center min-vh-100" style={{ minHeight: '100vh', width: '100vw' }}>
        <div className="auth-card shadow-lg rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.97)', minWidth: 340, maxWidth: 400 }}>
          <div className="text-center mb-4">
            <i className="bi bi-file-pdf display-4 text-primary mb-2"></i>
            <h1 className="fw-bold mb-1" style={{ letterSpacing: 1, fontSize: '2.2rem' }}>DataExtractor</h1>
          </div>
          <h2 className="text-center">Correo Enviado</h2>
          <p style={{ textAlign: 'center', margin: '1rem 0', color: '#666' }}>
            Se ha enviado un enlace de recuperación a tu correo electrónico.
            Revisa tu bandeja de entrada y sigue las instrucciones.
          </p>
          <p style={{ textAlign: 'center', fontSize: '0.875rem', color: '#888' }}>
            Si no recibes el correo en unos minutos, revisa tu carpeta de spam.
          </p>
          <div className="auth-links text-center mt-3">
            <Link to="/login">Volver al inicio de sesión</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-bg d-flex align-items-center justify-content-center min-vh-100" style={{ minHeight: '100vh', width: '100vw' }}>
      <div className="auth-card shadow-lg rounded-4 p-4" style={{ background: 'rgba(255,255,255,0.97)', minWidth: 340, maxWidth: 400 }}>
        <div className="text-center mb-4">
          <i className="bi bi-file-pdf display-4 text-primary mb-2"></i>
          <h1 className="fw-bold mb-1" style={{ letterSpacing: 1, fontSize: '2.2rem' }}>DataExtractor</h1>
          <div className="text-muted mb-2" style={{ fontSize: '1.1rem' }}>Recuperar Contraseña</div>
        </div>
        <p style={{ textAlign: 'center', margin: '1rem 0', color: '#666' }}>
          Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group mb-3">
            <label htmlFor="email" className="form-label">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              className="form-control"
              {...register('email', {
                required: 'El correo electrónico es requerido',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Formato de correo inválido'
                }
              })}
              placeholder="tu@email.com"
            />
            {errors.email && (
              <div className="error-message">{errors.email.message}</div>
            )}
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 mb-3"
            disabled={loading}
            style={{ fontWeight: 600, fontSize: '1.1rem' }}
          >
            <i className="bi bi-envelope"></i>
            {loading ? 'Enviando...' : 'Enviar Enlace'}
          </button>
        </form>
        <div className="auth-links text-center mt-3">
          <Link to="/login">Volver al inicio de sesión</Link>
          <div className="divider small">
            ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
